import { atom } from "recoil";
import {
	ALLOWED_EXTERNAL_HOSTS,
	REQUIRE_AUTH_OPTIONS,
	MAX_BANNER_BYTES,
	normalizeRequireAuthValue,
} from "./bannersAddModal";

export {
	ALLOWED_EXTERNAL_HOSTS,
	REQUIRE_AUTH_OPTIONS,
	MAX_BANNER_BYTES,
	normalizeRequireAuthValue,
};

export const bannersEditModalStore = atom({
	key: "bannersEditModalStore",
	default: {
		show: false,
		loaded: false,
		image: "",
		currentOption: {
			buttonType: [{value: "classic", label: "classic"}, {value: "main", label: "main",}, {value: "white", label: "white",}],
			buttonTextType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			linkType: [{value: "internal", label: "internal"}, {value: "external", label: "external",}, {value: "modal", label: "modal",}],
			titleType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			badgeType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			descriptionType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			descriptionDefaultType: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
			active: [{value: "0", label: "0"}, {value: "1", label: "1",}],
		},
		buttonTextType: "",
		buttonType: "",
		linkType: "",
		titleType: "",
		badgeType: "",
		descriptionType: "",
		descriptionDefaultType: "",
		active: { value: "0", label: "0" },
		buttonText: "",
		link: "",
		title: "",
		badge: "",
		personalization: false,
		description: "",
		descriptionDefault: "",
		analyticsID: "",
		requireAuth: "0",
		requireTg: false,
		requireEmail: false,
		order: "",
		from: "",
		to: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
